import { MenuItem, PrimeIcons } from "primeng/api";
import { AbstractMenuModule } from "../menu/abstract-menu-module";
import { ClientInfoModel, CargoFeaturesModel, AuthUserModel } from "../model";

const _menuItems = [{
    id: 'storagePanel',
    label: 'Склад',
    icon: PrimeIcons.TRUCK,
    routerLink: 'storagePanel',
},];


export class StoragePanelMenu extends AbstractMenuModule {
    override checkUserRole(roleName?: string): boolean {
        return roleName === 'storage';
    }
  
    override buildMenu(user?: ClientInfoModel, auth?: AuthUserModel, features?: CargoFeaturesModel): MenuItem[] {
        return this.copyMenuItems(_menuItems);
    }

}